export const INSPECTION_STATUS = {
    PENDING_USER: 'pendiente-usuario',
    PENDING_REVIEW: 'pendiente-revision',
    IN_PROGRESS: 'en-proceso',
    APPROVED: 'aprobado',
    REJECTED: 'rechazado'
};

export const INSPECTION_STATUS_LABELS = {
    'pendiente-usuario': 'Pendiente Usuario',
    'pendiente-revision': 'Pendiente Revisión',
    'en-proceso': 'En Proceso',
    'aprobado': 'Aprobado',
    'rechazado': 'Rechazado'
};

export const INSPECTION_STATUS_COLORS = {
    'pendiente-usuario': '#ff9800',
    'pendiente-revision': '#2196f3',
    'en-proceso': '#9c27b0',
    'aprobado': '#4caf50',
    'rechazado': '#f44336'
};

export const INSPECTION_STATUS_VERDICT = {
    PENDING: 'pendiente',
    IN_PROGRESS: 'en-proceso',
    APPROVED: 'aprobado',
    REJECTED: 'rechazado',
    COMPLETED: 'completado'
};

export const ROLES = {
    ADMINISTRATOR: 'Administrador',
    INSPECTOR: 'Inspector',
    CREATOR: 'Creador',
    CREATOR_SENIOR: 'Creador Senior'
};

export const INSPECTION_AREAS = {
    ANTECEDENTS: 'antecedents',
    VERDICTS: 'verdict',
    VISUAL_INSPECTION: 'visualInspection'
};

export const ALL_INSURANCE_COMPANIES = ['HOLDING', 'CNT', 'POLCHECK'];
export const ALL_INSURANCE_COMPANIES_VALUE = ALL_INSURANCE_COMPANIES.join(',');

export const INSURANCE_COMPANIES = [
    { label: 'HOLDING', value: 'HOLDING' },
    { label: 'CNT', value: 'CNT' },
    { label: 'POLCHECK', value: 'POLCHECK' },
    { label: 'OTRA', value: 'OTRA' }
];

export const PENDING_CARDS_RANGE_TIME = {
    NORMAL: {
        minMinutes: 0,
        maxMinutes: 5
    },
    WARNING: {
        minMinutes: 5,
        maxMinutes: 15
    },
    CRITICAL: {
        minMinutes: 15,
        maxMinutes: Infinity
    }
};

export const VEHICLE_TYPES = [
    { value: 'LIVIANO', label: 'LIVIANO' },
    { value: 'PESADO', label: 'PESADO' },
    { value: 'MOTOCICLETA', label: 'MOTOCICLETA' }
];

export const MAX_PHOTOS_PER_INSPECTION = 35;

export const OWNER_DOCUMENT_TYPES = [
    { value: 'CC', label: 'Cédula de ciudadanía (CC)' },
    { value: 'CE', label: 'Cédula de extranjería (CE)' },
    { value: 'NIT', label: 'NIT' },
    { value: 'PA', label: 'Pasaporte (PA)' },
    { value: 'TI', label: 'Tarjeta de identidad (TI)' },
    { value: 'CD', label: 'Carné diplomático (CD)' },
    { value: 'PPT', label: 'Permiso por protección temporal (PPT)' },
    { value: 'RC', label: 'Registro civil (RC)' },
];

const LEGACY_DOC_TYPE_MAP = {
    PP: 'PPT',
    TE: 'CE',
    PAS: 'PA',
};

export const toOfficialDocType = (value) => {
    const raw = String(value || '').toUpperCase().trim().replace(/\./g, '');
    return LEGACY_DOC_TYPE_MAP[raw] || raw;
};